// extracted by css-extract-rspack-plugin
var _1 = "kFACy";
var _2 = "IpjO_";
var _3 = "rEp5q";
var _4 = "_x5Fe";
var _5 = "Ax3AE";
var _6 = "lrhoT";
var _7 = "EHzGr";
var _8 = "ovzdD";
var _9 = "U0oqf";
var _a = "CcHXT";
export { _1 as "bullets", _2 as "fontBackColor", _3 as "fontColor", _4 as "fontIcon", _5 as "indent", _6 as "numbering", _7 as "outdent", _8 as "shading", _9 as "subscript", _a as "superscript" }
